export type TradeSide = 'long' | 'short';

function normalizeNonNegativePercent(value: number): number {
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Math.max(0, value);
}

export function clampFeePercent(value: number, maxPercent = 5): number {
  const normalized = normalizeNonNegativePercent(value);
  return Math.min(maxPercent, normalized);
}

export function roundTripFeePercent(makerFeePercent: number, takerFeePercent: number): number {
  return normalizeNonNegativePercent(makerFeePercent) + normalizeNonNegativePercent(takerFeePercent);
}

export function grossPnlPercent(entryPrice: number, exitPrice: number, side: TradeSide = 'long'): number {
  if (entryPrice <= 0) {
    return 0;
  }
  if (side === 'short') {
    return ((entryPrice - exitPrice) / entryPrice) * 100;
  }
  return ((exitPrice - entryPrice) / entryPrice) * 100;
}

export function netPnlPercentFromGross(
  grossPnlPercentValue: number,
  makerFeePercent: number,
  takerFeePercent: number,
): number {
  return grossPnlPercentValue - roundTripFeePercent(makerFeePercent, takerFeePercent);
}

export function netPnlPercentFromEntryExit(
  entryPrice: number,
  exitPrice: number,
  side: TradeSide,
  makerFeePercent: number,
  takerFeePercent: number,
): number {
  return netPnlPercentFromGross(
    grossPnlPercent(entryPrice, exitPrice, side),
    makerFeePercent,
    takerFeePercent,
  );
}
